import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'translations';

import style from './style.css';

const messages = {
  fromLabel: { id: 'TRIP_DETAILS.FROM' },
  toLabel: { id: 'TRIP_DETAILS.TO' },
  departing: { id: 'TRIP_DETAILS.DEPARTING' },
  arriving: { id: 'TRIP_DETAILS.ARRIVING' },
  forYourFlight: { id: 'TRIP_DETAILS.FOR_YOUR_FLIGHT' },
  forYourTrain: { id: 'TRIP_DETAILS.FOR_YOUR_TRAIN' },
  return: { id: 'SEARCH_FORM.RETURN_LABEL' },
  returning: { id: 'TRIP_DETAILS.RETURNING' },
  airlinePlaceholder: { id: 'BOOK_TRIP.AIRLINE.PLACEHOLDER' }
};

/**
 * Builder to show "Airline selector" label of the field and Airport name (to/from)
 * @param  {Component} ComposedComponent
 * @return {Component}
 */
const TripDirectionLabel = ({
  direction,
  stationName,
  airportName,
  className,
  returning
}) => {
  const modifiers = {
    [style['block--departing']]: !returning,
    [style['block--returning']]: returning
  };

  const titleMessage = stationName ? messages.forYourTrain : messages.forYourFlight
  const isDirectionToAirport = direction === 'dep';
  const tripTypeMsg = isDirectionToAirport ? messages.departing : messages.arriving;
  const conjunctionLabelMsg = isDirectionToAirport ? messages.fromLabel : messages.toLabel;
  const directionMessage = returning
    ? <FormattedMessage {...messages.return} />
    : '';

  return (
    <div className={classnames(style.block, modifiers, className)}>
      <label className={style.label}>
        <FormattedMessage
          {...titleMessage}
          values={{ direction: directionMessage }}
        />
        &nbsp;
        <FormattedMessage {...tripTypeMsg} />
      </label>
      <label className={style.labelDirection}>
        <FormattedMessage {...conjunctionLabelMsg} />
      </label>
      <label className={style.labelAirport}>
        {airportName || stationName}
      </label>
    </div>
  );
};

// TODO: move to Flow types
// TripDirectionLabel.propTypes = {
//   className: PropTypes.string,
//   name: PropTypes.string,
//   direction: PropTypes.oneOf(['departing', 'arriving']),
//   airportName: PropTypes.string.isRequired
// };

export default TripDirectionLabel;
